import { api, checkForUnauthorized, formatToLocalDate } from '@/utils';
import DossierOverviewTableInputs from '../DossierOverviewTableInputs/DossierOverviewTableInputs.vue';
import TableHeaderSorting from '../TableHeaderSorting/TableHeaderSorting.vue';

export default {
  name: 'DossierOverviewTable',
  components: {
    DossierOverviewTableInputs,
    TableHeaderSorting,
  },
  props: {},
  data: () => ({
    showDepartedDossiers: false,
    showAutomaticDossiers: false,
    formFields: {
      showDepartedDossiers: {
        label: 'Show departed dossier',
      },
      showAutomaticDossiers: {
        label: 'Show automatic dossier',
        name: 'automatic-dossier',
      },
    },
    headers: [
      { text: 'Dossier n', value: 'dossierN' },
      { text: 'Client', value: 'client' },
      { text: 'Ship', value: 'ship' },
      { text: 'Terminal', value: 'terminal' },
      { text: 'Berth', value: 'berth' },
      { text: 'Cargo', value: 'cargo' },
      { text: '', value: 'buttons' },
    ],
    dossiers: [],
    stakeholders: [],
    expanded: [],
    snackbar: false,
    snackbarText: String,
    loading: true,
    pageSize: 20,
    page: 1,
    apiVersion: 1,
    orderByField: 'DossierNumber',
    orderValue: 'DossierNumber',
    orderByDescending: true,
    dateMenu: false,
    searchInputs: {
      dossierN: '',
      ship: '',
      terminal: '',
      berth: '',
      cargo: '',
    },
    client: '',
    searchClients: null,
    automaticDossiersOptions: [{ text: 'All', value: null }, { text: 'Only automatic inputs', value: true }, { text: 'Contains manual inputs', value: false }],
  }),
  computed: {
    orderBy() {
      return this.orderByDescending ? 'Descending' : 'Ascending';
    },
    changeLoading(b) {
      this.loading = b;
    },
  },
  methods: {
    fetchDossiers() {
      this.loading = true;

      // BASEURL
      let url = '/dossiers?';

      // Order by and direction
      url += `order-by-field=${this.orderByField}&order-by=${this.orderBy}`;

      // Show departed dossier checkbox
      if (!this.showDepartedDossiers) {
        url += '&departed=false';
      }

      // Show automatic dossier
      if (this.showAutomaticDossiers != null) {
        url += `&only-automated-inputs=${this.showAutomaticDossiers}`;
      }

      // Page and Pagesize
      url += `&page=${this.page}&page-size=${this.pageSize}`;

      // cargo: free text
      if (this.searchInputs.cargo !== '') {
        const cargoReference = `${this.searchInputs.cargo}`;
        url += `&free-text=${encodeURIComponent(cargoReference.trim())}`;
      }

      // Dossier: dossier
      if (this.searchInputs.dossierN !== '') {
        const dossierReference = `${this.searchInputs.dossierN}`;
        url += `&dossier=${encodeURIComponent(dossierReference.trim())}`;
      }

      // client: stakeholder-id --> (INTEGER)
      if (this.client && this.client !== '') {
        if (!Number.isNaN(this.client)) {
          url += `&stakeholder-id=${parseInt(this.client, 10)}`;
        }
      }

      // ship: vessel-name
      if (this.searchInputs.ship !== '') {
        url += `&vessel-name=${this.searchInputs.ship}`;
      }

      // terminal: terminal
      if (this.searchInputs.terminal !== '') {
        url += `&terminal=${this.searchInputs.terminal}`;
      }

      // berth: berth
      if (this.searchInputs.berth !== '') {
        url += `&berth=${this.searchInputs.berth}`;
      }

      // Axios.get('https://api.myjson.com/bins/6whvh.json')
      api
        .get(url)
        .then((response) => {
          if (response.data.length <= 0) {
            this.snackbar = true;
            this.snackbarText = 'No (more) dossiers found.';
            if (this.page > 1) {
              this.page -= 1;
            }
          }
          response.data.forEach((dossier) => {
            const products = [];

            dossier.products.forEach((product) => {
              const productObj = {
                productName: product.productName,
                productCode: product.productCode,
              };

              products.push(productObj);
            });

            const cargoContents = [];
            dossier.cargoOverviews.forEach((cargoOverview) => {
              const foundProduct = products.find(product => product.productCode === cargoOverview.cargoContents);
              if (foundProduct) {
                foundProduct.unit = cargoOverview.cargoUnit;
                foundProduct.quantity = cargoOverview.cargoQuantity;
                foundProduct.operation = cargoOverview.cargoOperation;
              }
              cargoContents.push(cargoOverview.cargoContents);
            });

            let formattedDate;
            if (dossier.voyageEstimateArrivalDateTime) {
              formattedDate = formatToLocalDate(dossier.voyageEstimateArrivalDateTime);
            } else {
              formattedDate = 'No date available';
            }

            const obj = {
              id: dossier.id,
              dossierN: dossier.dossierNumber, // ??
              reference: dossier.requestingStakeholderReference.join(', '), // ??
              client: dossier.clientStakeholderName, // ??
              clientId: dossier.clientStakeholderId,
              ship: dossier.vesselName,
              imo: dossier.vesselImo,
              terminal: dossier.terminal,
              berth: dossier.berth,
              time: formattedDate, // ??
              cargo: cargoContents.join(', '),
              products,
              expanded: false,
              stayNumber: dossier.stayNumber,
              voyageNumber: dossier.voyageNumber,
            };
            this.dossiers.push(obj);
          });
          this.loading = false;
        })
        .catch((error) => {
          checkForUnauthorized(error);
          this.snackbar = true;
          this.snackbarText = `${error.response.status}: ${error.response.statusText}`;
        });
    },
    // eslint-disable-next-line func-names
    fetchSortedDossiers() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.dossiers = [];
        this.page = 1;
        this.fetchDossiers();
      }, 1000);
    },
    fetchMoreDossiers() {
      this.page += 1;
      this.fetchDossiers();
    },
    openExternalDossier(item) {
      const url = `${process.env.VUE_APP_QRONOPORT_PORTAL_BASE_URL}/voyages/${item.id}`;
      window.open(url);
    },
    addToDossier(item) {
      this.$router.push({ name: 'input-form', query: { dossierId: item.id } });
    },
    changeSorting(header) {
      if (this.orderValue === header.value && this.orderByDescending) {
        this.orderByDescending = false;
        this.orderValue = 'NextActivityEstimatedStart';
      } else if (this.orderValue === header.value) {
        this.orderByDescending = !this.orderByDescending;
        this.orderValue = header.value;
      } else {
        this.orderByDescending = false;
        this.orderValue = header.value;
      }

      // Change orderByField:
      if (this.orderValue === 'dossierN') {
        this.orderByField = 'DossierNumber';
      } else if (this.orderValue === 'time') {
        this.orderByField = 'NextActivityEstimatedStart';
      } else if (this.orderValue === 'reference') {
        this.orderByField = 'ClientReference';
      } else {
        this.orderByField = 'NextActivityEstimatedStart';
      }
      this.fetchSortedDossiers();
    },
    createNewInput() {
      this.$router.push({ name: 'input-form' });
    },
    querySelections(v) {
      this.loading = true;
      // Simulated ajax query
      setTimeout(() => {
        // SET STAKEHOLDER NAME PARAMETER = v
        api.get(`/stakeholders?name=${v}`).then((response) => {
          this.stakeholders = response.data;
        });
        this.loading = false;
      }, 1000);
    },
  },
  watch: {
    searchClients(val) {
      if (val) {
        this.dossiers = [];
        this.querySelections(val);
      }
    },
    searchInputs: {
      deep: true,
      handler() {
        this.fetchSortedDossiers();
      },
    },
    showDepartedDossiers() {
      this.fetchSortedDossiers();
    },
    showAutomaticDossiers() {
      this.fetchSortedDossiers();
    },
  },
  mounted() {
    this.fetchDossiers();
    // console.log(localStorage.getItem('token'));
  },
};
